var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"more-data",style:({ height: _vm.isOpen ? (_vm.maxHeight + 'px') : '0' })},[_c('div',{ref:"moreData"},[_vm._t("default")],2)]),_c('div',{class:`more-icon ${ _vm.isOpen ? 'icon-down' : 'icon-up' }`,style:(_vm.getStyle),on:{"click":_vm.handleClick}},[_c('i',{staticClass:"allIconFont"},[_vm._v("")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }